





















































import { StickyType } from '@spa/components/organisms/sticky/model/Types'
import Sticky from '@spa/components/organisms/sticky/Sticky.vue'
import Vue from 'vue'
import { Component, Emit, Prop } from 'vue-property-decorator'

@Component({
  components: {
    Sticky,
  },
})
export default class FloatingCheckout extends Vue {
  @Prop({ required: true })
  disabled: boolean

  @Prop({ required: true })
  totalPrice: string | undefined

  @Prop({ default: 'c-btn--positive' })
  buttonClass: string

  get stickyType(): StickyType {
    return StickyType.BOTTOM
  }

  @Emit('checkout')
  emitCheckout() {
    // Do nothing
  }
}
